import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useMediaQuery } from "_common/component/MediaQueryProvider";
import { useStores } from "_common/hooks";
import { Link } from "react-router-dom";
import { formatNumber } from "_common/utils/formatValue";

const FundList = observer(() => {
  const {
    authStore: { ieo },
  } = useStores();
  const { isMobile } = useMediaQuery();

  return (
    <div className="issuebox" id="zlbox">
      {ieo?.map((item) => (
        <Link to="/ieo" key={item?.id}>
          <div className="orebox">
            <div style={{ width: "100%", height: 120 }}>
              <div
                style={{
                  width: "30%",
                  height: 120,
                  lineHeight: 120,
                  float: "left",
                  textAlign: "center",
                }}
              >
                <img src={item?.image_url} style={{ width: "80%" }} alt="" />
              </div>
              <div
                style={{
                  width: "70%",
                  height: 120,
                  float: "left",
                  padding: 5,
                  position: "relative",
                }}
              >
                <p className="fzmmm fcc fw" style={{ marginBottom: 3 }}>
                  {item?.name}
                </p>
                <br />
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${item?.process}%` }}
                    aria-valuenow={item?.process}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {item?.process}%
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: 60,
                marginTop: 15,
                padding: "0px 15px",
              }}
            >
              <div className="obbox" style={{ width: "30%" }}>
                <div className="obbox_h">
                  <span className="fzmm fcc">Tiền tệ khai thác</span>
                </div>
                <div className="obbox_h">
                  <span className="fzmm fch">{item?.coin}</span>
                </div>
              </div>
              <div className="obbox" style={{ width: "40%" }}>
                <div className="obbox_h" style={{ textAlign: "center" }}>
                  <span className="fzmm fcc">Thời gian đầu tư</span>
                </div>
                <div className="obbox_h" style={{ textAlign: "center" }}>
                  <span className="fzmm fch">{item?.time} Ngày</span>
                </div>
              </div>
              <div className="obbox" style={{ width: "30%" }}>
                <div className="obbox_h" style={{ textAlign: "right" }}>
                  <span className="fzmm fcc">Số tiền đầu tư</span>
                </div>
                <div className="obbox_h" style={{ textAlign: "right" }}>
                  <span className="fzmm fch">
                    {formatNumber(item?.price, "0,0.00")}
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: 60,
                marginTop: 15,
                padding: "0px 15px",
              }}
            >
              <div className="obbox" style={{ width: "30%" }}>
                <div className="obbox_h">
                  <span className="fzmm fcc">Phương thức</span>
                </div>
                <div className="obbox_h">
                  <span className="fzmm fch">{item?.method}</span>
                </div>
              </div>
              <div className="obbox" style={{ width: "40%" }}>
                <div className="obbox_h" style={{ textAlign: "center" }}>
                  <span className="fzmm fcc">Thu nhập hàng ngày</span>
                </div>
                <div className="obbox_h" style={{ textAlign: "center" }}>
                  <span className="fzmm fch">
                    {formatNumber(item?.daily_profit, "0,0.00")} USDT
                  </span>
                </div>
              </div>
              <div className="obbox" style={{ width: "30%" }}>
                <div className="obbox_h" style={{ textAlign: "right" }}>
                  <span className="fzmm fcc">Số lượng còn lại</span>
                </div>
                <div className="obbox_h" style={{ textAlign: "right" }}>
                  <span className="fzmm fch">
                    {formatNumber(item?.quantity)}
                  </span>
                </div>
              </div>
            </div>
            <button type="button" className="btn2">
              Đầu tư ngay
            </button>
          </div>
        </Link>
      ))}
    </div>
  );
});

export default FundList;
